module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top10-ranking"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/sbmptn'
      }
    }
  }, [_vm._v("SBMPTN")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Top 10")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.tryoutGroupName))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab == 'IPA'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$router.fullpath
    },
    on: {
      "click": function($event) {
        return _vm.loadData('IPA')
      }
    }
  }, [_vm._v("IPA")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab == 'IPS'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$router.fullpath
    },
    on: {
      "click": function($event) {
        return _vm.loadData('IPS')
      }
    }
  }, [_vm._v("IPS")])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activeList), function(data) {
    return _c('tr', {
      key: data.id
    }, [_c('td', [_vm._v(_vm._s(data.rank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fullname.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.school))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.score * 100) / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.prodi_1))])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Siswa Top 10 UTBK\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("School")]), _vm._v(" "), _c('th', [_vm._v("Score")]), _vm._v(" "), _c('th', [_vm._v("Prodi 1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b86c73e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sbmptn/Top10Ranking.vue
// module id = 1350
// module chunks = 0